export default [

    // riepilogo situazione per utenti abilitati alla gestione
    {
        path: '/search/:type?/:id?',
        name: 'search',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'1', title:'headers.search-title'},
        components: {
            default: () => import(/* webpackChunkName: "search" */ './views/search'),
            'section-header': () => import(/* webpackChunkName: "search" */ './components/section-header')
        }
    },

    {
        path: '/search-results',
        name: 'search-results',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'1', title:'headers.search-list-title'},
        components: {
            default: () => import(/* webpackChunkName: "search" */ './views/search-list'),
            'section-header': () => import(/* webpackChunkName: "search" */ './components/section-header')
        }
    },

    {
        path: '/stored-search',
        name: 'stored-search',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'2', title:'headers.stored-search-title'},
        components: {
            default: () => import(/* webpackChunkName: "search" */ './views/stored-search-list'),
            'section-header': () => import(/* webpackChunkName: "search" */ './components/section-header')
        }
    },
    {
        path: '/product/:id',
        name: 'product-detail',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'1', title:'headers.product-title'},
        components: {
            default: () => import(/* webpackChunkName: "search" */ './views/product-detail'),
            'section-header': () => import(/* webpackChunkName: "search" */ './components/section-header')
        }
    },
    {
        path: '/product-new',
        name: 'product-new',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'1', title:'headers.product-new'},
        components: {
            default: () => import(/* webpackChunkName: "search" */ './views/product-new'),
            'section-header': () => import(/* webpackChunkName: "search" */ './components/section-header')
        }
    },
    {
        path: '/search-product-last-modified',
        name: 'search-product-last-modified',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'3', title:'headers.product-last-modified'},
        components: {
            default: () => import(/* webpackChunkName: "search" */ './views/product-last-modified'),
            'section-header': () => import(/* webpackChunkName: "search" */ './components/section-header')
        }
    },
    // gestione channels
    {
        path: '/product-compare-lists',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'2', subMenuActive:'4', title: 'headers.product-compare-list-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/product-compare-list-main'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'product-compare-list',
                meta: {keepAlive: true, title: 'headers.product-compare-list-title', mainMenuActive:'2', subMenuActive:'4'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/product-compare-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'product-compare-list-detail',
                meta: {keepAlive: false, title: 'headers.product-compare-list-detail', mainMenuActive:'2', subMenuActive:'4'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/product-compare-list-detail')
                }
            },
        ]
    },


];